import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListShortVideosComponent } from './list-short-videos/list-short-videos.component';

const routes: Routes = [
  {
    path: '',
    component: ListShortVideosComponent,
  },
  { path: '', pathMatch: 'full', redirectTo: 'catalog/shortVideos' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ShortVideosRoutingModule {}
